@use "../../../styles/breakpoint.module.scss" as *;

.root {
    composes: grid from "../../../styles/composable/layout.module.css";
    min-height: 100dvh;
    align-content: start;

    @media ($above-mobile) {
        margin-left: max(
            var(--labui-container-margin),
            env(safe-area-inset-left)
        );
        margin-right: max(
            var(--labui-container-margin),
            env(safe-area-inset-right)
        );
    }

    @media print {
        display: block !important;
        min-height: 0;
        margin-inline: 0;
    }
}

.header {
    grid-column: 3 / span 8;
    padding-block: var(--spacer-64);
    text-align: center;

    @media ($below-mobile) {
        grid-column: 1 / -1;
        margin-left: max(
            var(--labui-container-margin),
            env(safe-area-inset-left)
        );
        margin-right: max(
            var(--labui-container-margin),
            env(safe-area-inset-right)
        );
    }

    @media print {
        padding-block: 0 var(--spacer-24);
    }
}

.heading {
    font: var(--font-h-40);
    margin-bottom: var(--spacer-16);
}

.body {
    margin: 0 auto var(--spacer-16);
    font: var(--font-p-18);
    max-width: 650px;
}

.page {
    display: grid;
    grid-template-columns: subgrid;
    grid-column: 2 / span 10;
    margin-bottom: var(--spacer-104);

    @media ($below-mobile) {
        grid-column: 1 / -1;
    }

    @media print {
        display: block;
        margin-bottom: 0;
    }
}

.pageInner {
    grid-column: 2 / span 8;
    padding-block: var(--spacer-40);

    @media ($below-mobile) {
        grid-column: 1 / -1;
        padding-inline: var(--labui-container-margin);
    }
}

.actionsRow {
    display: flex;
    justify-content: center;
    gap: var(--spacer-16);
    margin-top: var(--spacer-8);

    @media ($below-mobile) {
        flex-direction: column;
        align-items: center;
    }

    @media print {
        display: none;
    }
}

.statusBar {
    grid-column: 1 / -1;
    border-bottom: 1px solid var(--gray-300);
}

.headerActions {
    display: flex;
    gap: var(--spacer-24);
    align-items: center;

    @media ($below-mobile) {
        display: none;
    }

    @media print {
        display: none;
    }
}

.headerActionButton {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
}

.headerActionSvg {
    width: 24px;
    height: 24px;
}
